<rt-zapier-integration
  (statusChange)="reloadAuthorizedClients()"
  [loading]="authorizedClientsLoading"
  [active]="authorizedClients ? !!authorizedClients.zapier : false"
  [clientId]="
    authorizedClients && authorizedClients.zapier ? authorizedClients.zapier.client.id : null
  "
  [teamIntegrationsCount]="(authorizedClientsCounters && authorizedClientsCounters.zapier) || 0"
/>
